// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"9e491247","213":"f559483f","349":"77b7f56d","453":"58d3a155","463":"ecacf252","667":"f4187d2e","695":"4a4a8f20","901":"0f7e1342"}[chunkId] + ".chunk.js";
};